import { render, staticRenderFns } from "./VisitInternal.vue?vue&type=template&id=b5216f04"
import script from "./VisitInternal.vue?vue&type=script&lang=js"
export * from "./VisitInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports